(function () {
const $5f0936c8b0990a8b$var$prefix = "[800js] \uD83D\uDE80";
// @todo: all log entries get pushed into an array that can be pushed to backend for telemetry
function $5f0936c8b0990a8b$export$1c9f709888824e05(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.debug(...args);
}
function $5f0936c8b0990a8b$export$a80b3bd66acc52ff(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.info(...args);
}
function $5f0936c8b0990a8b$export$c106dd0671a0fc2d(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.warn(...args);
}
function $5f0936c8b0990a8b$export$a3bc9b8ed74fc(...args) {
    if (!$5f0936c8b0990a8b$export$931813d4b9c88e2a()) return;
    console.error(...args);
}
function $5f0936c8b0990a8b$export$931813d4b9c88e2a() {
    return document?.cookie?.indexOf('_800dbg') !== -1 || window?._800js?.debug === true;
}


const $d0b7dfbc17617186$var$phoneNumberRegex = /(?:(?:\+?([1-9]|[0-9][0-9]|[0-9][0-9][0-9])\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([0-9][1-9]|[0-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?/g;
const $d0b7dfbc17617186$var$nodeContainsPhoneNumber = (node)=>{
    if (node.innerHTML?.includes('tel:')) return true;
    if (node.textContent?.trim() === '') return false;
    if (!node.textContent?.match(/\d/)) return false;
    // if (! node.textContent?.match(phoneNumberRegex)) {
    //     return false;
    // }
    return true;
};
const $d0b7dfbc17617186$export$9e32ceef92e19c15 = (node)=>{
    const nodes = [];
    // -----------------------------
    // #1: Process the current node
    // -----------------------------
    if (node.parentElement instanceof HTMLScriptElement) return nodes;
    if (node.parentElement?.closest('.no-swap')) return nodes;
    if (node.nodeType === Node.TEXT_NODE) // if (node.nodeValue?.match(phoneNumberRegex)) {
    return [
        node
    ];
    if (node instanceof HTMLAnchorElement /* &&
        node.getAttribute('href')?.match(phoneNumberRegex) */ ) nodes.push(node);
    // -----------------------------
    // #2: Process child nodes
    // -----------------------------
    if (!$d0b7dfbc17617186$var$nodeContainsPhoneNumber(node)) return nodes;
    for(let i = 0; i < node.childNodes.length; i++)nodes.push(...$d0b7dfbc17617186$export$9e32ceef92e19c15(node.childNodes.item(i)));
    return nodes;
};
const $d0b7dfbc17617186$var$getUnprocessedNodeFilter = (cache)=>{
    return function(node) {
        // debug('Swapper.observeNode', node);
        // #1: Check if node is already in cache
        if (cache.has(node)) // debug('Swapper.observeNode: node already in cache', node);
        return false;
        // #2: Add node to cache
        // debug('Swapper.observeNode: observed node first time', node);
        cache.add(node);
        return true;
    };
};
const $d0b7dfbc17617186$var$logMutationText = (node)=>{
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('[mutation] Detected text node:', node.textContent);
    return node;
};
const $d0b7dfbc17617186$export$ca12be886f5e4fed = (callback)=>{
    const cache = new WeakSet();
    const nodeFilter = $d0b7dfbc17617186$var$getUnprocessedNodeFilter(cache);
    const observer = new MutationObserver((mutations)=>{
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)("Observed mutation");
        mutations.filter((mutation)=>mutation.addedNodes.length !== 0).forEach((mutation)=>{
            Array.from(mutation.addedNodes).map((node)=>{
                $d0b7dfbc17617186$export$9e32ceef92e19c15(node).filter(nodeFilter).forEach(callback);
            });
        });
    });
    function onDomContentLoaded() {
        // Perform walk on domcontentloaded (todo: DRY)
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('DOMContentLoaded: performing walk');
        const nodes = $d0b7dfbc17617186$export$9e32ceef92e19c15(document.body);
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('DOMContentLoaded: walk discovered', nodes.length, 'nodes');
        nodes.filter(nodeFilter).forEach(callback);
    }
    document.addEventListener('DOMContentLoaded', onDomContentLoaded);
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('Document Ready State:', document.readyState);
    if (document.readyState === 'complete' || document.readyState === 'interactive') $d0b7dfbc17617186$export$9e32ceef92e19c15(document.body).filter(nodeFilter).forEach(callback);
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('observing changes');
    observer.observe(document, {
        childList: true,
        subtree: true,
        characterData: true
    });
    // stop the watcher.
    return ()=>{
        document.removeEventListener('DOMContentLoaded', onDomContentLoaded);
        observer.disconnect();
    };
};


var $5ceb1485e1c336c7$exports = {};
'use strict';
$5ceb1485e1c336c7$exports = $5ceb1485e1c336c7$var$isMobile;
$5ceb1485e1c336c7$exports.isMobile = $5ceb1485e1c336c7$var$isMobile;
$5ceb1485e1c336c7$exports.default = $5ceb1485e1c336c7$var$isMobile;
const $5ceb1485e1c336c7$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $5ceb1485e1c336c7$var$notMobileRE = /CrOS/;
const $5ceb1485e1c336c7$var$tabletRE = /android|ipad|playbook|silk/i;
function $5ceb1485e1c336c7$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $5ceb1485e1c336c7$var$mobileRE.test(ua) && !$5ceb1485e1c336c7$var$notMobileRE.test(ua) || !!opts.tablet && $5ceb1485e1c336c7$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


let $a6af0f4fc1a7d864$var$lastEventCount = undefined;
let $a6af0f4fc1a7d864$var$lastDataLayerCaptured = {};
const $a6af0f4fc1a7d864$var$removeEmptyValues = (obj)=>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v])=>v !== null && v !== ''));
};
const $a6af0f4fc1a7d864$export$6411f84b48e7973c = (items)=>{
    if (items.length === 0) return {};
    if (items.length === 1) return $a6af0f4fc1a7d864$var$removeEmptyValues({
        ...items[0]
    });
    const firstItem = {
        ...items[0]
    };
    const reduced = items.slice(1).reduce((acc, item)=>{
        for(const key in item)if (acc[key] !== item[key]) // Null when there are conflicting values.
        acc[key] = null;
        for(const key in acc)if (item[key] === undefined) // Null when there are conflicting values.
        acc[key] = null;
        return acc;
    }, firstItem);
    return $a6af0f4fc1a7d864$var$removeEmptyValues(reduced);
};
const $a6af0f4fc1a7d864$var$isEqual = (a, b)=>{
    return Object.keys(a).every((key)=>a[key] === b[key]) && Object.keys(b).every((key)=>a[key] === b[key]);
};
const $a6af0f4fc1a7d864$export$422e45e5b4ae11c3 = ()=>{
    if (!window.asc_datalayer) return {};
    let capture;
    capture = $a6af0f4fc1a7d864$export$6411f84b48e7973c(window.asc_datalayer.items || []);
    capture.page_type = window.asc_datalayer.page_type;
    capture.affiliation = window.asc_datalayer.affiliation;
    // --------------------------------------------------------------
    // These fields could be available, but not currently used by us
    // --------------------------------------------------------------
    //   capture.currency = window.asc_datalayer.currency;
    //   capture.language = window.asc_datalayer.language;
    //   capture.oem_code = window.asc_datalayer.oem_code;
    //   capture.oem_brand = window.asc_datalayer.oem_brand;
    //   capture.store_name = window.asc_datalayer.store_name;
    return capture;
};
const $a6af0f4fc1a7d864$var$captureAscDataLayer = ()=>{
    if (!window.asc_datalayer) return;
    const capture = $a6af0f4fc1a7d864$export$422e45e5b4ae11c3();
    if ($a6af0f4fc1a7d864$var$isEqual(capture, $a6af0f4fc1a7d864$var$lastDataLayerCaptured)) return;
    $a6af0f4fc1a7d864$var$lastDataLayerCaptured = capture;
    window.dispatchEvent(new CustomEvent('800dni.asc-datalayer', {
        detail: {
            dataLayer: capture
        }
    }));
};
const $a6af0f4fc1a7d864$var$checkForNewAscEvents = ()=>{
    const eventCount = window.asc_datalayer?.events?.length || 0;
    if (eventCount === $a6af0f4fc1a7d864$var$lastEventCount) return;
    // We've had new events since the last data layer capture
    // so it's possible the other data in data_layer has changed.
    $a6af0f4fc1a7d864$var$lastEventCount = eventCount;
    $a6af0f4fc1a7d864$var$captureAscDataLayer();
};
const $a6af0f4fc1a7d864$export$1ef0a386b5db328d = ()=>{
    setTimeout(()=>{
        $a6af0f4fc1a7d864$var$captureAscDataLayer();
        $a6af0f4fc1a7d864$var$lastEventCount = window.asc_datalayer?.events?.length || 0;
        setInterval($a6af0f4fc1a7d864$var$checkForNewAscEvents, 500);
    }, 500);
};


let $f666fece0d4e83e8$var$eventFired = false;
const $f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE = 'data-800-ctc-listener';
const $f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE = 'data-800-ctc-wrapper';
const $f666fece0d4e83e8$var$addClickListenerToNode = (node, numberE164)=>{
    if (node.hasAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE)) return;
    node.toggleAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE, true);
    const fireClickToCallEvent = ()=>{
        if ($f666fece0d4e83e8$var$eventFired) return;
        // We could have an event listener bound to multiple elements 
        // such that the event fires multiple times for a single click.
        // We do not want to mess with event propagation as we 
        // might break something outside of our control.
        // This code guards against excessive events firing.
        setTimeout(()=>$f666fece0d4e83e8$var$eventFired = false, 5000);
        $f666fece0d4e83e8$var$eventFired = true;
        // Firefox sometimes aborts the request with NS_BINDING_ABORTED error. 
        // By using a timeout, this doesn't happen anymore.
        setTimeout(()=>{
            window.dispatchEvent(new CustomEvent('800dni.asc-event', {
                detail: {
                    ascEventName: 'asc_click_to_call',
                    ascEventData: {
                        ...(0, $a6af0f4fc1a7d864$export$422e45e5b4ae11c3)(),
                        comm_phone_number: numberE164
                    }
                }
            }));
        });
    };
    // Many devices have the option to call after selecting text.
    //   (e.g. with a long press on the phone number)
    // We should treat that as a click to call, as that's probably the intention.
    node.addEventListener('selectstart', fireClickToCallEvent);
    node.addEventListener('click', fireClickToCallEvent);
};
const $f666fece0d4e83e8$var$addClickTracking = (node, text, numberE164)=>{
    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A' && String(node.getAttribute('href')).substring(4) === text) {
        // We're looking at an anchor tag, so anything inside is part of the C2C. 
        $f666fece0d4e83e8$var$addClickListenerToNode(node, numberE164);
        return;
    }
    // Node is a has a single child text node with nothing but the text
    if (node.childNodes.length === 1 && node.childNodes[0].nodeType === Node.TEXT_NODE) {
        const nodeText = node.childNodes[0].nodeValue || '';
        if (nodeText === text || nodeText.trim() === text) {
            $f666fece0d4e83e8$var$addClickListenerToNode(node, numberE164);
            return;
        }
    }
    // Node has multiple child nodes or the text is not the only thing in the node
    for(let i = 0; i < node.childNodes.length; i++){
        const childNode = node.childNodes[i];
        if (childNode.nodeType === Node.ELEMENT_NODE) {
            if (childNode.hasAttribute($f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE) || childNode.hasAttribute($f666fece0d4e83e8$var$CTC_LISTENER_ADDED_ATTRIBUTE)) continue;
            $f666fece0d4e83e8$var$addClickTracking(childNode, text, numberE164);
        }
        if (childNode.nodeValue === null || childNode.parentNode === null || childNode.nodeType !== Node.TEXT_NODE) continue;
        if (!childNode.nodeValue?.includes(text)) continue;
        const parts = childNode.nodeValue.split(text);
        const parentNode = childNode.parentNode;
        for(let i = 0; i < parts.length; i++){
            // Insert any text that is not part of the phone number
            parentNode.insertBefore(document.createTextNode(parts[i]), childNode);
            if (i < parts.length - 1) {
                // Insert the phone number, wrapped in a clickable span
                const wrapperSpan = document.createElement('span');
                // This should help prevent any CSS applying to this element.
                wrapperSpan.setAttribute('style', 'all: unset !important');
                wrapperSpan.toggleAttribute($f666fece0d4e83e8$var$CTC_WRAPPER_ATTRIBUTE, true);
                wrapperSpan.append(document.createTextNode(text));
                parentNode.insertBefore(wrapperSpan, childNode);
                $f666fece0d4e83e8$var$addClickListenerToNode(wrapperSpan, numberE164);
            }
        }
        // Keep a reference to the old parent node 
        // as we may see the same child again if it 
        // contained multiple phone numbers.
        childNode.danglingChildParentNode = parentNode;
        parentNode.removeChild(childNode);
    }
};
const $f666fece0d4e83e8$export$c0f3019f7e74c5cf = (e)=>{
    const { replacement: replacement, replacementE164: replacementE164, node: node } = e.detail;
    if ('danglingChildParentNode' in node) {
        // We've processed this node before, and then removed it from the DOM 
        // as part of the process that adds a wrapper span. 
        $f666fece0d4e83e8$var$addClickTracking(node.danglingChildParentNode, replacement, replacementE164);
        return;
    }
    if (node.parentNode !== null && node.parentNode.nodeType === Node.ELEMENT_NODE) $f666fece0d4e83e8$var$addClickTracking(node.parentNode, replacement, replacementE164);
};
const $f666fece0d4e83e8$export$76b46e2f8835d97 = ()=>{
    // Only run on mobile/tablet devices
    if (!(0, $5ceb1485e1c336c7$exports.isMobile)({
        tablet: true
    })) return;
    window.addEventListener('800dni.swap', $f666fece0d4e83e8$export$c0f3019f7e74c5cf);
};


class $94a83508004090d1$export$2e2bcd8739ae039 {
    constructor(callTracking, phoneNumberRenderer, undoPhoneNumberRenderer){
        this.callTracking = callTracking;
        this.renderer = phoneNumberRenderer;
        this.undoPhoneNumberRenderer = undoPhoneNumberRenderer;
    }
    static getInstance(callTracking, phoneNumberRenderer, undoPhoneNumberRenderer) {
        if (!$94a83508004090d1$export$2e2bcd8739ae039.instance) $94a83508004090d1$export$2e2bcd8739ae039.instance = new $94a83508004090d1$export$2e2bcd8739ae039(callTracking, phoneNumberRenderer, undoPhoneNumberRenderer);
        return $94a83508004090d1$export$2e2bcd8739ae039.instance;
    }
    run() {
        const stop = (0, $d0b7dfbc17617186$export$ca12be886f5e4fed)(async (node)=>{
            if (this.callTracking.current?.swaps) this.renderer(node, this.callTracking.current.swaps);
        });
        this.callTracking.pending.then((response)=>{
            stop();
            this.undoPhoneNumberRenderer();
            if (response?.isSessionTrackingEnabled) (0, $f666fece0d4e83e8$export$76b46e2f8835d97)();
            if (response?.swaps) (0, $d0b7dfbc17617186$export$ca12be886f5e4fed)(async (node)=>{
                this.renderer(node, response.swaps);
            });
        });
        return this;
    }
}







function $8ed3c7b9a73a82be$export$82112e1a17c2a69b(number) {
    if (number.startsWith('+1')) return number;
    if (number.startsWith('1')) return '+' + number;
    return '+1' + number;
}
function $8ed3c7b9a73a82be$export$277d7fa50e12435e(targetFormat, phoneNumber) {
    const replacementChars = phoneNumber.split('');
    const originalChars = targetFormat.split('').filter((c)=>c !== "\n");
    if (targetFormat.match(/([a-zA-Z])/)) return $8ed3c7b9a73a82be$export$277d7fa50e12435e('(000) 000-0000', phoneNumber);
    for(let i = originalChars.length; i > 0; i--)if (originalChars[i - 1] !== ' ' && !isNaN(originalChars[i - 1])) originalChars[i - 1] = replacementChars.pop();
    return originalChars.join('');
}
function $8ed3c7b9a73a82be$export$e236fc13b12bbcd4(text) {
    const formattedPhoneNumbers = [];
    for (let match of text.matchAll((0, $09918bacc8c2dda0$export$ed1198d4679e93aa))){
        const [originalFormat, ...groups] = match;
        const parts = groups.slice(0, -1);
        formattedPhoneNumbers.push({
            originalFormat: originalFormat,
            raw: parts.join('')
        });
    }
    return formattedPhoneNumbers;
}
const $8ed3c7b9a73a82be$var$defaultOptions = {
    ignoreId: false
};
function $8ed3c7b9a73a82be$export$4e26f457d394e36b(el, customOptions) {
    const options = {
        ...$8ed3c7b9a73a82be$var$defaultOptions,
        ...customOptions
    };
    let nodeElem = el;
    if (nodeElem && nodeElem.id && !options.ignoreId) return "//*[@id=\"" + nodeElem.id + "\"]";
    let parts = [];
    while(nodeElem && Node.ELEMENT_NODE === nodeElem.nodeType){
        let nbOfPreviousSiblings = 0;
        let hasNextSiblings = false;
        let sibling = nodeElem.previousSibling;
        while(sibling){
            if (sibling.nodeType !== Node.DOCUMENT_TYPE_NODE && sibling.nodeName === nodeElem.nodeName) nbOfPreviousSiblings++;
            sibling = sibling.previousSibling;
        }
        sibling = nodeElem.nextSibling;
        while(sibling){
            if (sibling.nodeName === nodeElem.nodeName) {
                hasNextSiblings = true;
                break;
            }
            sibling = sibling.nextSibling;
        }
        let prefix = nodeElem.prefix ? nodeElem.prefix + ":" : "";
        let nth = nbOfPreviousSiblings || hasNextSiblings ? "[" + (nbOfPreviousSiblings + 1) + "]" : "";
        parts.push(prefix + nodeElem.localName + nth);
        nodeElem = nodeElem.parentNode;
    }
    return parts.length ? "/" + parts.reverse().join("/") : "";
}



const $09918bacc8c2dda0$export$ed1198d4679e93aa = new RegExp(/(?:(?:\+?([1-9]\d{0,2})\s*(?:[.-]\s*)?)?)?(?:(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|(?:\(([0-9]{3})\)\s*|([0-9]{3})))(?:\s*(?:[.-]\s*)?(\d)\s*(?:[.-]\s*)?(\d)\s*(?:[.-]\s*)?(\d)(?:\s*(?:[.-]\s*)?(\d))?(?:\s*(?:[.-]\s*)?(\d))?(?:\s*(?:[.-]\s*)?(\d))?(?:\s*(?:[.-]\s*)?(\d))?(?:\s*(?:[.-]\s*)?(\d))?(?:\s*(?:[.-]\s*)?(\d))?|\s*(?:[.-]\s*)?([A-Za-z0-9])\s*(?:[.-]\s*)?([A-Za-z0-9])\s*(?:[.-]\s*)?([A-Za-z0-9])(?:\s*(?:[.-]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.-]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.-]\s*)?([A-Za-z0-9]))?(?:\s*(?:[.-]\s*)?([A-Za-z0-9]))?)(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?(?=[A-Z]{0,5}[.\-\s]|$)/g);
let $09918bacc8c2dda0$var$changes = [];
const $09918bacc8c2dda0$export$45e8ee9780092531 = ()=>{
    for (const [type, node, value] of $09918bacc8c2dda0$var$changes){
        if (type === 'text') node.nodeValue = value;
        else if (type === 'href') node.setAttribute('href', value);
    }
    $09918bacc8c2dda0$var$changes = [];
};
const $09918bacc8c2dda0$export$328f4521fd6579bd = (node, swaps)=>{
    const swapTargetList = swaps.reduce((targets, swap)=>[
            ...targets,
            ...swap.swapTargets
        ], []);
    const pendingEvents = [];
    const replaceTextValue = (text)=>{
        return (0, $8ed3c7b9a73a82be$export$e236fc13b12bbcd4)(text).reduce((result, phoneNumber)=>{
            const target = (0, $8ed3c7b9a73a82be$export$82112e1a17c2a69b)(phoneNumber.raw).toUpperCase();
            const swap = swaps.filter((swap)=>swap.swapTargets.includes(target)).pop();
            if (swap === undefined) return result;
            const replacement = (0, $8ed3c7b9a73a82be$export$277d7fa50e12435e)(phoneNumber.originalFormat, swap.number);
            (0, $5f0936c8b0990a8b$export$1c9f709888824e05)(`swapping ${phoneNumber.raw} -> ${swap.number}`);
            pendingEvents.push(new CustomEvent('800dni.swap', {
                detail: {
                    node: node,
                    replacement: replacement,
                    replacementE164: swap.number,
                    original: phoneNumber.originalFormat,
                    originalE164: target,
                    selector: (0, $8ed3c7b9a73a82be$export$4e26f457d394e36b)(node.parentElement)
                }
            }));
            return result.replace(phoneNumber.originalFormat, replacement);
        }, text);
    };
    const replaceHrefAttribute = (node)=>{
        const href = node.getAttribute('href');
        if (href) {
            node.setAttribute('href', replaceTextValue(decodeURI(href)));
            $09918bacc8c2dda0$var$changes.push([
                'href',
                node,
                href
            ]);
        }
    };
    if (node instanceof HTMLAnchorElement) replaceHrefAttribute(node);
    else {
        const replacement = replaceTextValue(String(node.nodeValue));
        if (replacement !== node.nodeValue) {
            $09918bacc8c2dda0$var$changes.push([
                'text',
                node,
                String(node.nodeValue)
            ]);
            node.nodeValue = replacement;
            if (node.parentElement) replaceHrefAttribute(node.parentElement);
        }
    }
    for (const event of pendingEvents)window.dispatchEvent(event);
};





const $c143955347d96110$var$SESSION_KEY = '800cltrk.session';
function $c143955347d96110$export$70f660b32d482235(options) {
    const init = async (sessionId)=>{
        const response = await fetch(options.apiUrl, {
            method: 'POST',
            body: JSON.stringify({
                sessionId: sessionId,
                // It's up to the BE to decide if the URL counts as a new 
                // session/touch or if it's a continuation of an existing one.
                landingPage: options.pageContext.url,
                referrer: options.pageContext.referrer,
                date: new Date().toISOString()
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        if (response.status !== 200) {
            (0, $5f0936c8b0990a8b$export$a3bc9b8ed74fc)(await response.text());
            throw new Error('Received non-200 response while fetching swaps');
        }
        const payload = await response.json();
        return payload.data;
    };
    const existingSession = options.storage.get($c143955347d96110$var$SESSION_KEY);
    const sessionInitPromise = init(existingSession?.sessionId);
    sessionInitPromise.then((response)=>{
        if (response) options.storage.set($c143955347d96110$var$SESSION_KEY, {
            sessionId: response.sessionId,
            swaps: response.swaps
        }, 31536000);
        else console.warn('DNI incomplete setup: missing sessionId or swaps from API response.');
    });
    return {
        current: existingSession,
        pending: sessionInitPromise
    };
}




class $7e114494d61b838c$export$19fffca37ef3e106 {
    static{
        this.internalCache = {};
    }
    constructor(ttl){
        this.ttl = ttl;
    }
    hydrateInternalCache(key) {
        if ($7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] !== undefined) return;
        const result = localStorage.getItem(key);
        if (result === null) {
            $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] = null;
            return;
        }
        $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key] = JSON.parse(result);
    }
    get(key) {
        this.hydrateInternalCache(key);
        const result = $7e114494d61b838c$export$19fffca37ef3e106.internalCache[key];
        if (result === null || result.data === null) {
            window.dispatchEvent(new CustomEvent('800dni.cache.miss', {
                detail: {
                    key: key
                }
            }));
            return null;
        }
        if (result.expires && result.expires < new Date().getTime()) {
            window.dispatchEvent(new CustomEvent('800dni.cache.prune', {
                detail: {
                    key: key
                }
            }));
            this.set(key, null);
            return null;
        }
        window.dispatchEvent(new CustomEvent('800dni.cache.hit', {
            detail: {
                key: key
            }
        }));
        // hit
        return result.data;
    }
    set(key, data, ttl = this.ttl) {
        const expires = ttl === 0 ? 0 : new Date().getTime() + ttl * 1000;
        localStorage.setItem(key, JSON.stringify({
            data: data,
            expires: expires
        }));
        window.dispatchEvent(new CustomEvent('800dni.cache.set', {
            detail: {
                key: key,
                data: data
            }
        }));
    }
}




var $f4d178fc3dfdbd39$export$2e2bcd8739ae039 = (0, $94a83508004090d1$export$2e2bcd8739ae039);



class $c40af09e17faf3ea$var$EventStorage {
    push(e) {
        this.events.push(e);
    }
    drain() {
        const events = this.events;
        this.events = [];
        return events;
    }
    constructor(){
        this.events = [];
    }
}
const $c40af09e17faf3ea$export$cde790f843eb5aed = (url, token, sessionId)=>{
    const eventStorage = new $c40af09e17faf3ea$var$EventStorage();
    const pushDecoratedEvent = (kind)=>(e)=>{
            eventStorage.push({
                ...e.detail,
                date: new Date().toISOString(),
                kind: kind
            });
        };
    window.addEventListener('800dni.asc-datalayer', pushDecoratedEvent('asc_datalayer'));
    window.addEventListener('800dni.asc-event', pushDecoratedEvent('asc_event'));
    window.addEventListener('800dni.ga-session', pushDecoratedEvent('ga_session'));
    window.addEventListener('800dni.ga-client', pushDecoratedEvent('ga_client'));
    window.addEventListener('800dni.page_view', pushDecoratedEvent('page_view'));
    // don't think we want to send this. Doesn't seem like a useful event.
    // window.addEventListener('800dni.swap', pushDecoratedEvent('swap'));
    window.addEventListener('800dni.error', pushDecoratedEvent('error'));
    const send = ()=>{
        setTimeout(()=>{
            const events = eventStorage.drain();
            if (events.length > 0) fetch(`${url}/dniEvents`, {
                method: 'POST',
                body: JSON.stringify({
                    token: token,
                    events: events,
                    sessionId: sessionId
                }),
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                })
            }).then(()=>{}).catch((err)=>{
                // noop? We can't report the error.
                console.error(err);
            });
            send();
        }, 100);
    };
    send();
};


const $f1240072de177995$var$clientPattern = new RegExp(/(^|\s)_ga=G[AS]\d\.\d\.(\d+)\.(\d*?)(;|$)/);
const $f1240072de177995$var$sessionPattern = new RegExp(/(^|\s)_ga_(\w+)=GS\d\.\d\.(\d+)\.(\d+)\.\d+\.\d+\.\d+\.0\.0(;|$)/g);
function $f1240072de177995$var$initClientTracking() {
    const matches = document.cookie.match($f1240072de177995$var$clientPattern);
    if (matches) {
        window.dispatchEvent(new CustomEvent('800dni.ga-client', {
            detail: {
                clientId: matches[2],
                clientNumber: matches[3]
            }
        }));
        return;
    }
    setTimeout($f1240072de177995$var$initClientTracking, 500);
}
function $f1240072de177995$var$initSessionTracking(foundSessions) {
    const matches = document.cookie.matchAll($f1240072de177995$var$sessionPattern);
    const newFoundSessions = [];
    for (const match of matches){
        const [, , sessionName, sessionId, sessionNumber] = match;
        if (!foundSessions.includes(sessionName)) {
            newFoundSessions.push(sessionName);
            window.dispatchEvent(new CustomEvent('800dni.ga-session', {
                detail: {
                    sessionName: sessionName,
                    sessionId: sessionId,
                    sessionNumber: sessionNumber
                }
            }));
        }
    }
    setTimeout(()=>{
        $f1240072de177995$var$initSessionTracking([
            ...foundSessions,
            ...newFoundSessions
        ]);
    }, 500);
}
function $f1240072de177995$export$5b824a20ba9ccd3() {
    $f1240072de177995$var$initClientTracking();
    $f1240072de177995$var$initSessionTracking([]);
}


const $8086f1c1703dac18$export$7c4dafd94c1cbb03 = function(url, token, sessionId) {
    const requestUrl = `${url}/dniHeartbeat`;
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            token: token,
            sessionId: sessionId
        }),
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    };
    const beat = ()=>{
        fetch(requestUrl, requestOptions).catch(()=>{
        // Do nothing
        });
    };
    setInterval(beat, 60000);
};


window._800js ||= {};
window._800testing ||= {};
const $2d081a1fa49e40a2$var$getPageContext = ()=>{
    return {
        url: window._800testing?.url || window.location.href,
        referrer: window._800testing?.referrer || document.referrer
    };
};
const $2d081a1fa49e40a2$var$script = document.currentScript;
const $2d081a1fa49e40a2$var$current = $2d081a1fa49e40a2$var$script ? new URL($2d081a1fa49e40a2$var$script.src) : null;
const $2d081a1fa49e40a2$var$token = $2d081a1fa49e40a2$var$current?.searchParams.get('token') || $2d081a1fa49e40a2$var$script?.getAttribute('data-token') || String(undefined);
const $2d081a1fa49e40a2$var$url = ($2d081a1fa49e40a2$var$current?.searchParams.get('backend') || $2d081a1fa49e40a2$var$script?.getAttribute('data-backend') || String(undefined))// remote trailing slash because we need to build different URL paths
.replace(/\/$/, '');
if (!$2d081a1fa49e40a2$var$url) (0, $5f0936c8b0990a8b$export$a3bc9b8ed74fc)('missing url');
if ($2d081a1fa49e40a2$var$url) {
    const storage = new (0, $7e114494d61b838c$export$19fffca37ef3e106)(window._800js.ttl || 3600);
    const pageContext = $2d081a1fa49e40a2$var$getPageContext();
    const callTracking = (0, $c143955347d96110$export$70f660b32d482235)({
        storage: storage,
        apiUrl: `${$2d081a1fa49e40a2$var$url}/calltrk/${$2d081a1fa49e40a2$var$token}`,
        pageContext: pageContext
    });
    (0, $5f0936c8b0990a8b$export$a80b3bd66acc52ff)('booting', window._800js);
    const app = (0, $f4d178fc3dfdbd39$export$2e2bcd8739ae039).getInstance(callTracking, (0, $09918bacc8c2dda0$export$328f4521fd6579bd), (0, $09918bacc8c2dda0$export$45e8ee9780092531)).run();
    (0, $5f0936c8b0990a8b$export$1c9f709888824e05)('started app');
    if ((0, $5f0936c8b0990a8b$export$931813d4b9c88e2a)()) Object.assign(window._800js, {
        app: app
    });
    (async ()=>{
        const swapResponse = await callTracking.pending;
        if (!swapResponse?.sessionId || !swapResponse?.isSessionTrackingEnabled) return;
        const sessionId = swapResponse?.sessionId;
        (0, $5f0936c8b0990a8b$export$1c9f709888824e05)({
            sessionId: sessionId
        });
        (0, $c40af09e17faf3ea$export$cde790f843eb5aed)($2d081a1fa49e40a2$var$url, $2d081a1fa49e40a2$var$token, sessionId);
        (0, $8086f1c1703dac18$export$7c4dafd94c1cbb03)($2d081a1fa49e40a2$var$url, $2d081a1fa49e40a2$var$token, sessionId);
        (0, $f1240072de177995$export$5b824a20ba9ccd3)();
        (0, $a6af0f4fc1a7d864$export$1ef0a386b5db328d)();
        window.dispatchEvent(new CustomEvent('800dni.page_view', {
            detail: {
                url: pageContext.url,
                referrer: pageContext.referrer || null
            }
        }));
    })();
}

})();
//# sourceMappingURL=index.js.map
